import { Column, Container, Row, url, useFlipperQuery } from "lcm-iot-commons";
import { Link } from "react-router-dom-v5-compat";
import NavigationLegalPages from "../NavigationLegalPages";

/* eslint-disable react/no-unescaped-entities */
export default function Legal() {
  const { data: flipper } = useFlipperQuery();
  const showTermsVersion2025 = flipper?.showTermsVersion2025;

  return (
    <Container>
      <Row>
        <NavigationLegalPages />
        <Column md={9}>
          <h1 data-testid="legal-header">Legal</h1>

          {showTermsVersion2025 ? (
            <>
              <h3>Master Service Agreement (“Agreement”)</h3>
              <p>
                Here you can read our Master Service Agreement. &nbsp;{" "}
                <Link to={url("/legal/master-service-agreement")}>-&gt;</Link>
              </p>
            </>
          ) : (
            <>
              {" "}
              <h3>Terms of Service</h3>
              <p>
                Here you can read our Terms of Service. &nbsp;{" "}
                <Link to={url("/legal/terms-of-service")}>-&gt;</Link>
              </p>
              <h3>API-Terms</h3>
              <p>
                Here you can read our API-Terms. &nbsp;{" "}
                <Link to={url("/legal/api-terms")}>-&gt;</Link>
              </p>
            </>
          )}

          <h3>Service Level Agreement</h3>
          <p>
            Here you can read our Service Level Agreement. &nbsp;{" "}
            <Link to={url("/legal/service-level-agreement")}>-&gt;</Link>
          </p>
          <h3>Privacy Policy</h3>
          <p>
            Learn more about our Privacy Policy &nbsp;{" "}
            <Link to={url("/legal/privacy-policy")}>-&gt;</Link>
          </p>

          <h3>Security Policy</h3>
          <p>
            Your data security and data privacy is our highest goal. Learn more
            about how we handle your data &nbsp;{" "}
            <Link to={url("/legal/security-policy")}>-&gt;</Link>
          </p>

          {showTermsVersion2025 && (
            <>
              <h3>Acceptable Use Policy</h3>
              <p>
                Here you can read our Acceptable Use Policy &nbsp;{" "}
                <Link to={url("/legal/acceptable-use-policy")}>-&gt;</Link>
              </p>

              <h3>Data Localization Policy</h3>
              <p>
                Here you can read our Data Localization Policy &nbsp;{" "}
                <Link to={url("/legal/data-localization-policy")}>-&gt;</Link>
              </p>

              <h3>Definition of Service: Netilion Connect</h3>
              <p>
                Here you can read our Definition of Service: Netilion Connect
                &nbsp;{" "}
                <Link to={url("/legal/definition-netilion-connect")}>
                  -&gt;
                </Link>
              </p>

              <h3>Definition of Service: Netilion One</h3>
              <p>
                Here you can read our Definition of Service: Netilion One &nbsp;{" "}
                <Link to={url("/legal/definition-netilion-one")}>-&gt;</Link>
              </p>

              <h3>Definition of Service: Process Water</h3>
              <p>
                Here you can read our Definition of Service: Process Water
                &nbsp;{" "}
                <Link to={url("/legal/definition-netilion-process-water")}>
                  -&gt;
                </Link>
              </p>
            </>
          )}
        </Column>
      </Row>
    </Container>
  );
}
